import React, { Component } from 'react';
import { Button, Icon, Image, Grid,Label } from 'semantic-ui-react';
import {Carousel} from 'react-responsive-carousel';
// eslint-disable-next-line 
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import {isValidArr, isMobile} from '../utils'

const renderBtn = (dir, onClick, btnStyle) => {
  if(dir!=='left' && dir!=='right')return null;
  return (<Button className="navBtn" 
            style={{[dir]:btnStyle.pos, 
            background: btnStyle.background,
            ...Style.button, ...Style.button[btnStyle.shape],
          }} icon onClick= {onClick}> 
              <Icon name={`${Style.button.iconPrefix} ${dir}`} 
              size={Style.button.size} color={Style.button.color}
              fitted/>
            </Button>);
}
const renderSlides = (slides, onPrev, onNext, btnStyle) => {
  if(!isValidArr(slides)) return null;
  slides.sort((s1,s2)=> {return (s1.id > s2.id) ? 1 : -1});
  const firstId = slides[0].id;
  const lastId = slides[slides.length-1].id;
  
  return slides.map(slide => {
    const onPrevEv = onPrev && slide.id > firstId ? () => {onPrev();} : null;
    const onNextEv = onNext && slide.id < lastId ? () => {onNext();} : null;

    return (
    <div style={Style.main}>
      {/* <Grid.Column position='right'> */}
          <div>
            <Image className ='image' src={slide.image}/>
            {/* <div style={Style.pageTxt}>{slide.text}</div> */}
            <Label style={Style.pageTxt}>{slide.text}</Label>

            {/* { onPrevEv && renderBtn('left', onPrevEv, btnStyle)}
            { onNextEv && renderBtn('right', onNextEv, btnStyle)} */}
          </div>
        {/* </Grid.Column> */}
    </div>);
 });
}

class Slider extends Component {

  static defaultProps = {
    selectedItem: 0,
    // axis: 'horizontal'
    axis: 'vertical'
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedItem: props.selectedItem,    
      lastPos: props.slides && props.slides.length > 0 ? props.slides.length -1 : 0,
      axis: props.axis || 'horizontal',
      // axis: 'vertical'
    }
  }
  
  slideTo = (index, axis = 'horizontal') => {
    if(this.props.slides.length > index && index >= 0){
      this.setState({
        selectedItem: index,
        axis
      });
    }
  }

  slideNext = (axis) => {
    const next = this.state.selectedItem < this.state.lastPos ?
    this.state.selectedItem + 1 : this.state.lastPos;
    this.setState({
      selectedItem: next,
      axis
   });
  }

  slidePrev = (axis) => {
    const prev = this.state.selectedItem > 0 ? this.state.selectedItem - 1 : 0;
    this.setState({
      selectedItem: prev,
      axis
   });
  }

  setAxisH = () => {
    this.setState({ axis:'horizontal'});
  }

  setAxisV = () => {
    this.setState({ axis:'vertical'});
  }

  slideRight = () => {
    this.slideNext('horizontal');
  }

  slideLeft = () => {
    this.slidePrev('horizontal');
  }

  slideUp = () => {
    this.slideNext('vertical');
  }

  slideDown = () => {
    this.slidePrev('vertical');
  }
 
  render() {
    return (      
      <div style={this.props.style}>
        <Carousel
        autoPlay={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        // useKeyboardArrows
        className="presentation-mode" 
        showArrows={false}
        showIndicators={false}
        // axis='horizontal'
        axis={this.state.axis}
        //verticalSwipe="natural"
        verticalSwipe= 'standard'
        width= '100%'
        emulateTouch
        centerMode
        centerSlidePercentage={100}
        // onChange={()=>alert('onChange')} 
        // onClickItem={()=>alert('onClickItem')} 
        // onClickThumb={()=>alert('onClickThumb')}
        selectedItem = {this.state.selectedItem}
        dynamicHeight ={true}>
          {renderSlides(this.props.slides, this.slideLeft, this.slideRight, this.props.button)}
        </Carousel>
      </div>
    );
  }
}
const mobile = isMobile();
const Style = {
  main: {
    height:'100%', 
    width:'100%', 
    background:'lightgray'
  },
  pageTxt: {
    height: 'auto',
    //width: 'auto',
    color: '#604020',//996633',
    //text-shadow: 3px 0 green, 0 3px green, 3px 0 green, 0 3px green'
    fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
    fontSize: mobile? '0.8rem':'3rem',
    fontWeight: '900',
    // margin: '50% 60% 0 0%', 
    position: 'absolute',
    bottom: mobile ? '0.5rem':'2rem',
    left: mobile ? '0.5rem':'2rem',
    //textAlign: 'center', 
    background:'lightgray',
    opacity: mobile?'0.9':'0.7',
  },
  button: {
    iconPrefix:'chevron',
    size:'big',
    circle:{
      height: '60px',
      width: '60px',
      borderRadius: '5em',
    },
    square:{
      height: '50px',
      width: '50px',
    },
    rectang:{
      height: '100px',
      width: '40px',
    },
    margin: '0 20px',
    opacity: 0.4,
  },
}
export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider.js